export interface BackContext {
  label: string;
  backRouteType: string;
  backRoutePayload: Record<string, any>;
  /** Query string of the page to return to, replayed so the exact URL (incl. query) is restored. */
  backRouteQuery?: Record<string, any>;
}

/**
 * sessionStorage key holding the project/org the Profile page was opened from. The Profile URL
 * carries no id, so this is how its back button survives a reload. It is session-scoped (not
 * localStorage) so it never resurfaces as a stale button on a fresh login, and it is cleared on
 * logout and whenever Profile is opened from an org/project-agnostic page.
 */
export const PROFILE_BACK_ORIGIN_STORAGE_KEY = "profileBackOrigin";

export interface ProfileBackOrigin {
  projectId?: string | null;
  organizationId?: string | null;
}
